<template>
  <v-menu
    offset-y
    min-width="260"
    max-width="320"
    content-class="um-dropdown"
    transition="slide-y-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn text tile v-bind="attrs" v-on="on" class="um-activator">
        <v-avatar size="36px" class="um-avatar">
          <img
            alt="Avatar"
            :src="require('@/assets/avatars/Frame-' + $store.getters.avatar + '.svg')"
          />
        </v-avatar>
        <span class="um-username">{{ $store.getters.fullName }}</span>
        <v-icon size="18" class="um-chevron">mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-card class="um-card" elevation="8">
      <!-- User header -->
      <div class="um-header">
        <v-avatar size="44px" class="um-header-avatar">
          <img
            alt="Avatar"
            :src="require('@/assets/avatars/Frame-' + $store.getters.avatar + '.svg')"
          />
        </v-avatar>
        <div class="um-header-info">
          <div class="um-header-name">{{ $store.getters.fullName }}</div>
        </div>
      </div>
      <v-divider class="mx-3" style="opacity: 0.15"></v-divider>
      <!-- Menu items -->
      <div class="um-menu-items">
        <v-list-item link :to="{ name: 'Profile' }" class="um-menu-item">
          <div class="um-item-icon um-item-icon--profile">
            <v-icon size="18" color="white">mdi-account-outline</v-icon>
          </div>
          <v-list-item-title class="um-item-text">{{ $t('profile.title') }}</v-list-item-title>
          <v-icon size="16" color="grey lighten-1">mdi-chevron-right</v-icon>
        </v-list-item>
        <!-- <v-list-item class="um-menu-item"> -->
        <!-- <div class="um-item-icon um-item-icon--org">
            <v-icon size="18" color="white">mdi-office-building-outline</v-icon>
          </div> -->
        <!-- <v-list-item-title class="um-item-text">{{ $t('profile.myOrg') }}</v-list-item-title> -->
        <!-- <v-icon size="16" color="grey lighten-1">mdi-chevron-right</v-icon> -->
        <!-- </v-list-item> -->
        <v-divider class="mx-4 my-1" style="opacity: 0.1"></v-divider>
        <v-list-item @click="logout" class="um-menu-item um-menu-item--logout">
          <div class="um-item-icon um-item-icon--logout">
            <v-icon size="18" color="white">mdi-logout-variant</v-icon>
          </div>
          <v-list-item-title class="um-item-text um-item-text--logout">{{
            $t('logout')
          }}</v-list-item-title>
        </v-list-item>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import util from '@/mixins/util.js';

export default defineComponent({
  name: 'UserMenu',
  mixins: [util],
  setup() {},
});
</script>

<style scoped>
/* Activator Button */
.um-activator {
  text-transform: none !important;
  letter-spacing: 0 !important;
  padding: 4px 12px !important;
  border-radius: 12px !important;
  transition: all 0.25s ease !important;
}
.um-activator:hover {
  background: rgba(0, 64, 94, 0.06) !important;
}

.um-avatar {
  border: 2px solid rgba(0, 64, 94, 0.15);
  transition: border-color 0.25s ease;
}
.um-activator:hover .um-avatar {
  border-color: rgba(0, 64, 94, 0.35);
}

.um-username {
  margin-left: 8px;
  margin-right: 2px;
  font-size: 0.88rem;
  font-weight: 600;
  color: #e6edf0;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.um-chevron {
  color: #90a4ae !important;
  transition: transform 0.25s ease !important;
}
.v-menu--attached .um-chevron,
.um-activator--active .um-chevron {
  transform: rotate(180deg);
}

/* Dropdown Card */
.um-card {
  border-radius: 14px !important;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

/* Header */
.um-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 18px 14px;
  background: linear-gradient(135deg, #00405e 0%, #006494 50%, #0097a7 100%);
}

.um-header-avatar {
  border: 2px solid rgba(255, 255, 255, 0.3);
  flex-shrink: 0;
}

.um-header-info {
  overflow: hidden;
}

.um-header-name {
  color: white;
  font-size: 0.95rem;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Menu Items */
.um-menu-items {
  padding: 6px 0;
}

.um-menu-item {
  margin: 2px 8px;
  border-radius: 10px !important;
  min-height: 42px;
  transition: all 0.2s ease !important;
  display: flex;
  align-items: center;
  gap: 10px;
}
.um-menu-item:hover {
  background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 50%, #e8f5e9 100%) !important;
}

.um-item-icon {
  width: 32px;
  height: 32px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.um-item-icon--profile {
  background: linear-gradient(135deg, #1976d2, #42a5f5);
}
.um-item-icon--org {
  background: linear-gradient(135deg, #7b1fa2, #ab47bc);
}
.um-item-icon--logout {
  background: linear-gradient(135deg, #c62828, #ef5350);
}

.um-item-text {
  font-size: 0.88rem !important;
  font-weight: 600 !important;
  color: #37474f !important;
}
.um-item-text--logout {
  color: #c62828 !important;
}

.um-menu-item--logout:hover {
  background: linear-gradient(135deg, #ffebee 0%, #fce4ec 100%) !important;
}
</style>
